export default "__VITE_ASSET__7aeba476__"